import { get, post, put } from '../request'

export const createInventory = (params) => post('api/inventories', params)
export const updateInventory = (id, params) => put(`api/inventories/${id}`, params)
export const getInventories = (filters, pagination) =>
  get('api/inventories', {
    filters,
    pagination,
    populate: ['equipment', 'target_project', 'target_stockroom', 'create_user', 'accept_user', 'attachment'],
  })
export const getEquipmentInventories = (equipment) =>
  get('api/inventories', {
    filters: { equipment },
    populate: ['target_project', 'target_stockroom', 'create_user', 'accept_user'],
  })
export const fetchInventory = (id) => get(`api/inventories/${id}`, { populate: ['attachment'] })
export const generateAcceptanceAct = (id) => get('api/inventories/generate/act', { id }, { responseType: 'blob' })
export const acceptInventory = (id) => put(`api/inventories/accept/${id}`)
export const acceptInventoryBulk = (params) => put(`api/inventories/bulk/accept`, params)
export const rejectInventory = (id) => put(`api/inventories/reject/${id}`)
export const rejectInventoryBulk = (params) => put(`api/inventories/bulk/reject`, params)
